import type { FooterCopy } from '@/app/(site)/chrome-copy'

export type FooterLink = {
    label: string
    href?: string
    onClick?: () => void
}

export type FooterLinkId = keyof FooterCopy

const DMCA_POLICY_URL = 'https://support.giphy.com/hc/en-us/articles/360020287091-GIPHY-DMCA-Copyright-Policy'

/**
 * The legal links both menu footers render. Each footer chooses its own order
 * and styling to match its design; the destinations and the cookie-preferences
 * hook live here so desktop and mobile cannot drift apart.
 */
export const getFooterLinks = (copy: FooterCopy): Record<FooterLinkId, FooterLink> => ({
    privacyPolicy: { label: copy.privacyPolicy, href: '/privacy' },
    termsOfService: { label: copy.termsOfService, href: '/terms' },
    dmca: { label: copy.dmca, href: DMCA_POLICY_URL },
    copyright: { label: copy.copyright, href: '/dmca' },
    manageCookies: {
        label: copy.manageCookies,
        onClick: () => {
            window.Didomi?.preferences.show()
        },
    },
})
